import React, { useContext, useState } from 'react';
import { StyledMonthSlider } from './index.styles';
import { CalendarContext } from '../index.context';
import { Actions, MonthNames } from '../index.constants';
import { Icon } from '../../../Atoms';
import { StyledSelect, StyledItems, StyledItem } from '../index.styles';

const months = Array.from({ length: 12 }).map((value, i) => i);

export const Months = ({ ...otherProps }) => {
    const {
        dispatch,
        state: { date },
    } = useContext(CalendarContext);

    const month = date.getMonth();

    const [openItems, setOpenItems] = useState(false);

    const getItems = () => (
        <StyledItems>
            {months.map(m => (
                <StyledItem
                    key={m}
                    onClick={() => dispatch({ type: Actions.SELECT_MONTH, month: m })}
                >
                    {MonthNames[m]}
                </StyledItem>
            ))}
        </StyledItems>
    );

    return (
        <StyledMonthSlider {...otherProps}>
            <StyledSelect onClick={() => setOpenItems(prev => !prev)}>
                {MonthNames[month]}
                <Icon padLeft icon={['fas', 'angle-down']} />
                {openItems && getItems()}
            </StyledSelect>
        </StyledMonthSlider>
    );
};
